import { Link } from "react-router-dom";
import { services } from "@/mocks/services";

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-24 bg-white" id="services">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="inline-block bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-3">
            Our Services
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4">
            Complete Insurance & Financial Solutions
          </h2>
          <p className="text-slate-600 text-base md:text-lg leading-relaxed">
            From health to retirement, we provide end-to-end advisory for every stage of your financial journey.
            Compare, analyze, and choose with confidence.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.route}
              className="group bg-slate-50 hover:bg-white rounded-2xl p-6 border border-slate-100 hover:border-primary-200 transition-all duration-300 hover:shadow-lg"
            >
              <div
                className={`w-12 h-12 rounded-xl ${service.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
              >
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-2 group-hover:text-primary-700 transition-colors">
                {service.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed line-clamp-3">
                {service.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                <span>Learn More</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <Link
            to="/compare-plans"
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm px-6 py-3 rounded-full transition-colors"
          >
            <i className="ri-arrow-left-right-line"></i>
            Compare All Plans Side-by-Side
          </Link>
        </div>
      </div>
    </section>
  );
}